<template>
    <app-content-admin>
        <template slot="header">Edit Project</template>
               
        <v-layout row wrap>

<v-flex xs12 lg6 mx-auto>
    <v-card>
        <v-card-text>           
            <v-container fluid grid-list-xs>
                <v-layout wrap>

                    <v-flex xs12>
                        <v-text-field
                            :label="$t('Firebase project name')"
                            v-model="form.firebase_project_name"
                            :rules="[rules.required('Firebase project name')]"
                            outlined
                        >
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field
                            :label="$t('Firebase project id')"
                            v-model="form.firebase_project_id"
                            :rules="[rules.required('Firebase project id')]"
                            outlined
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field
                            :label="$t('Firebase project number')"
                            v-model="form.firebase_project_number"
                            :rules="[rules.required('Firebase project number')]"
                            outlined
                        >
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-file-input
                            :label="$t('Firebase service account (json file)')"
                            :rules="[rules.required('Firebase service account')]"
                            v-model="jsonFile"
                            outlined
                            accept=".json"
                        >
                        </v-file-input>
                    </v-flex>

                </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="updateProject"
                class="form-submit"
            >
                Submit
            </v-btn>
        </v-card-actions>
    </v-card>

</v-flex>

</v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from '../../components/status/ActiveLabel.vue';
import store from '@/store'


export default {
    mixins: [vForm],

    data(){
        return {     
            jsonFile:null,
            form: {
                // firebase_project_name: "test",
                // firebase_project_id: "test-d87c9",
                // firebase_project_number:'656890956246',
                // firebase_service_account:'test-d87c9-firebase-adminsdk-vtxcr-7579150601.json'
                firebase_project_name: null,
                firebase_project_id: null,
                firebase_project_number:null,
                firebase_service_account:null,
                id_project:null        
            },
                       
          }
        },

        components: {ActiveLabel},

        created() {

            this.form.id_project = this.$route.params.id;
            console.log(this.form.id_project);
            this.getProject();
        },

        methods: {
            async updateProject(){
                let loader = this.$loading.show();
                try{
                let path = await this.uploadJSON();
                console.log(path)
                this.form.firebase_service_account = path;
                let token = store.getters['auth/token'];
                let res = await axios.post(`/api/cloud/update_firebase_project?token=${token}`,this.form)
                     if(res.status == 200){
                        this.$toastr.s(' project updated successfully');  
                      
                    }
                }
                catch(err){
                    this.$toastr.e(err.response.data.message);
                }
                finally{
                    loader.hide();                   
                }
            },

            filenameToFile(filename) {
              const blob = new Blob([], { type: 'application/octet-stream' });
              blob.lastModifiedDate = new Date();
              blob.name = filename;
             
              const file = new File([blob], filename);
              return file;
            },


            async getProject(){
                let loader = this.$loading.show();
                try{
                let token = store.getters['auth/token'];
                let res = await axios.get(`/api/cloud/get_firebase_project?token=${token}`
                 , {params:{id_project:this.form.id_project}})
                     if(res.data.status == "success"){
                        this.form.firebase_project_name = res.data.data.result.firebase_project_name;
                        this.form.firebase_project_id = res.data.data.result.firebase_project_id
                        this.form.firebase_project_number = res.data.data.result.firebase_project_number
                        this.form.firebase_service_account = res.data.data.result.firebase_service_account
                        const filename = this.filenameToFile(this.form.firebase_service_account);
                        console.log(filename);
                        this.jsonFile = filename;
                      console.log(res.data);
                       
                    }
                }
                catch(err){
                    this.$toastr.e(err.response.data.message);
                }
                finally{
                    loader.hide();                   
                }
            },

            async uploadJSON(){
                var formData = new FormData();
                formData.append('firebase_service_account',this.jsonFile)
                try{
                let token = store.getters['auth/token'];
                const config = {
                   headers:{
                       'Content-Type' : 'multipart/form-data',
                   }
                 };
                let res = await axios.post(`/api/cloud/upload_json?token=${token}`,formData, config)
                return res.data.data.path                   
                }
                catch(err){
                    this.$toastr.e(err.response.data.message);
                }                
            },
            fileChange(e){
                this.jsonFile = e;
            },         

        }
}
</script>